import { Injectable } from "@angular/core";
import { ApiBaseService } from "./api-base.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";
import * as moment from 'moment';

@Injectable({
  providedIn: "root"
})
export class DynamicLayoutService extends ApiBaseService {
  constructor(private configService: ConfigService, private http: HttpClient, private us: UserService) {
    super(us);
    this.httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", SessionId: this.userService.sessionId }) };
    this.baseUrl = `${this.configService.config.directUrl}/api/core`;
  }

  GetCurrentSubMenus(): Observable<any> {
    const moduleFunctionId = this.userService.getCurrentModuleFunctionId()
    return this.http.get<any>(`${this.baseUrl}/GetDynamicSubMenuByModuleFunction?moduleFunctionId=${moduleFunctionId}`, this.httpOptions);
  }

  GetSubMenuItem(moduleFunctionDynamicSubMenuId: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/GetDynamicSubMenuItem?moduleFunctionDynamicSubMenuId=${moduleFunctionDynamicSubMenuId}`, this.httpOptions);
  }

  GetSubMenuItemData(dynamicLayoutId: number, fromDate: moment.Moment, toDate: moment.Moment): Observable<any> {
    let fromDateParameter = "";
    let toDateParameter = "";
    if (fromDate != null && toDate != null) {
      fromDateParameter = `&fromDate=${fromDate.toISOString()}`;
      toDateParameter = `&toDate=${toDate.toISOString()}`;
    }
    return this.http.get<any>(`${this.baseUrl}/GetSubMenuItemData?dynamicLayoutId=${dynamicLayoutId}${fromDateParameter}${toDateParameter}`, this.httpOptions);
  }

  getLayoutColumns(data: any, useWidth: boolean, useCustomDateFormat: boolean = false) {
    if (data == null || data.length === 0 || data.Tiles == null || data.Tiles.length === 0 || data.DataRows == null) { return []; }

    const columns = [];
    for (let i = 0; i < data.Tiles[0].Columns.length; i++) {
      const col = data.Tiles[0].Columns[i];
      let colSetting: any = {};
      switch (col.ColumnDataType.toLowerCase()) {
        case "int":
        case "double":
          colSetting = { dataField: col.Name, caption: col.Label, dataType: "number", visible: col.DisplayMode_Visible };
          break;
        case "datetime":
          const format = !useCustomDateFormat ? { day: "2-digit", month: "2-digit", year: "numeric" } : "dd.MM.yyyy";
          colSetting = { dataField: col.Name, caption: col.Label, dataType: "date", format: format, visible: col.DisplayMode_Visible };
          break;
        case "boolean":
          colSetting = { dataField: col.Name, caption: col.Label, dataType: "boolean", visible: col.DisplayMode_Visible };
          break;
        default:
          colSetting = { dataField: col.Name, caption: col.Label, dataType: "string", visible: col.DisplayMode_Visible };
          break;
      }

      if (useWidth && col.Width != null && col.Width !== "") {
        colSetting.width = col.Width;
      }

      colSetting.allowEditing = !col.EditMode_ReadOnly;

      columns.push(colSetting);
    }

    return columns;
  }

  getLayoutDataSource = (data: any) => {
    if (data == null || data.length === 0 || data.Tiles === null || data.DataRows === null) { return []; }

    const columns = [];
    const tiles = data.Tiles;

    if (tiles.length > 0) {
      const columnsBuf = tiles[0].Columns;
      for (let i = 0; i < columnsBuf.length; i++) {
        const rec: any = {};
        rec.Name = columnsBuf[i].Name;
        columns.push(rec);
      }
    }

    const dataRows = data.DataRows;
    const dataSource = [];

    for (let i = 0; i < dataRows.length; i++) {
      const rec: any = {};
      const rowtilesBuf = dataRows[i].RowTiles;

      rec.ReadOnly = data.DataRows[i].ReadOnly;
      rec.IsEditable = data.DataRows[i].IsEditable;

      if (rowtilesBuf.length > 0) {
        const valuesBuf = rowtilesBuf[0].Values;
        if (valuesBuf.length > 0) {
          for (let j = 0; j < valuesBuf.length; j++) {
            rec[columns[j].Name] = valuesBuf[j].Value;
          }
        }
      }

      dataSource.push(rec);
    }

    return dataSource;
  }
}
